let sequence = 1000

export function nextSequence(): number {
  sequence += 1
  return sequence
}

export function businessNo(prefix: string, sequenceValue?: number): string {
  const value = sequenceValue ?? nextSequence()
  return `${prefix}${String(value).padStart(6, '0')}`
}

export function requestNo(): string {
  const date = new Date()
  const ymd = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}`
  return `REQ-${ymd}-${String(nextSequence()).slice(-6)}`
}
